import React, { useState } from 'react';
import { compose } from 'ramda';
import { RouteComponentProps } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Select, showToast } from '@deeptrue-frontend/ui';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import api from 'api/api';
import RouterProvider from 'components/RouterProvider/RouterProvider';

const { connect, selectors, actions } = StoreProvider;
const { withRouter, ROUTES } = RouterProvider;

const LanguageSwitcher = ({
  language,
  setLanguage,
  match: { path },
}: {
  language: string;
  setLanguage: (language: string) => void;
} & RouteComponentProps) => {
  const [isUpatingProfile, setIsUpdatingProfile] = useState(false);
  const updateUserProfile = (lang: string) => {
    if (language === lang.toString() || isUpatingProfile) return;
    setIsUpdatingProfile(true);
    api.resources.updateUserProfile({ language: lang.toString() }).then(() => {
      setLanguage(lang.toString());
      setIsUpdatingProfile(false);

      showToast({
        type: 'success',
        // INFO use formatmessage as hooks have delay with changing lang, notification was always provided in old language, in formatMessage this problem doesnt occurs
        /* eslint-disable-next-line */
        // @ts-ignore KRZYŚ
        title: <FormattedMessage id="errors.settings.changesSave" />,
      });
    });
  };

  const isBriefingCreatorLoaded = path === ROUTES.ORGANIZATION.PRODUCTS;
  return (
    <Select
      onChange={(_name: any, val: any) => updateUserProfile(val)}
      name="langSwitch"
      direction="top"
      disabled={isBriefingCreatorLoaded}
      value={language}
      options={[
        {
          value: 'en',
          label: 'English',
        },
        {
          value: 'fr',
          label: 'Français',
        },
        {
          value: 'de',
          label: 'Deutsch',
        },
        {
          value: 'it',
          label: 'Italiano',
        },
      ]}
    />
  );
};

export default compose(
  connect(
    (state) => ({
      language: selectors.intlSelectors.language(state),
    }),
    {
      setLanguage: actions.intlActions.setLanguage,
    }
  ),
  withRouter
)(LanguageSwitcher);
